<template>
  <el-dialog :visible="visible" @close="close">
    <el-form v-if="!success" :rules="rules" :model="form" label-position="top" ref="form">
      <el-form-item label="Type">
        <el-input disabled value="Café de marie (Portugal)"></el-input>
      </el-form-item>
      <el-form-item label="ID du magasin" prop="id">
        <el-input placeholder="Ex: 1933" v-model="form.id"/>
      </el-form-item>
      <el-form-item label="Nom du magasin" prop="name">
        <el-input placeholder="Ex: Gotham city" v-model="form.name"/>
      </el-form-item>
      <el-form-item label="Email du magasin" prop="email">
        <el-input placeholder="city@gothamcity.fr" v-model="form.email"/>
      </el-form-item>
      <el-form-item label="Email du manager de secteur" prop="managerDeSecteurEmail">
        <el-input placeholder="batman@gothamcity.fr" v-model="form.managerDeSecteurEmail"/>
      </el-form-item>
      <el-button
        type="primary"
        v-loading="loading" @click="createShop">Créer le magasin
      </el-button>
    </el-form>
    <div v-if="success">
      <el-alert :closable="false" type="success">Le magasin a été créé</el-alert>
      <div style="margin-top: 15px;"></div>
      <el-button @click="openShop" type="success">Ouvrir le magasin</el-button>
    </div>
  </el-dialog>
</template>

<script>
import services from 'services';

export default {
  props: { visible: { type: Boolean, default: false } },
  methods: {
    close() {
      this.$emit('close');
    },
    async createShop() {
      this.loading = true;
      this.$refs.form.validate(async (valid) => {
        if (!valid) {
          this.loading = false;
          return;
        }
        try {
          const data = await services.shopService.createShop({
            id: this.form.id,
            name: this.form.name,
            email: this.form.email,
            managerDeSecteurEmail: this.form.managerDeSecteurEmail,
          }, this.form.shopType);
          this.success = true;
          this.$emit('created', {
            ...data,
            type: this.form.shopType,
          });
        } catch (e) {
          this.$message.error('Une erreur est survenue');
        } finally {
          this.loading = false;
        }
      });
    },
    async openShop() {
      await this.$router.push({
        name: 'ShopPage',
        params: {
          shopId: this.form.id,
        },
        query: {
          shopType: this.form.shopType,
        },
      });
    },
  },
  data() {
    return {
      form: {
        id: '',
        name: '',
        email: '',
        managerDeSecteurEmail: '',
        shopType: services.shopService.shopTypes.CDM_PRT,
      },
      success: false,
      loading: false,
    };
  },
  computed: {
    rules() {
      return {
        id: [
          { required: true, message: this.$t('commons.requiredFieldMessage'), trigger: 'blur' },
        ],
        name: [
          { required: true, message: this.$t('commons.requiredFieldMessage'), trigger: 'blur' },
        ],
        email: [
          { required: true, message: this.$t('commons.requiredFieldMessage'), trigger: 'blur' },
          { type: 'email', message: this.$t('commons.validEmailRequiredMessage'), trigger: 'blur' },
        ],
        managerDeSecteurEmail: [
          { required: true, message: this.$t('commons.requiredFieldMessage'), trigger: 'blur' },
          { type: 'email', message: this.$t('commons.validEmailRequiredMessage'), trigger: 'blur' },
        ],
      };
    },
  },
};
</script>
